// API de la app «Google» (resumen de la pestaña Cuenta):
//   GET /api/v1/admin/google-calendar/status (google_calendar:read, mcp_django #498)
// Conectar/desconectar y la agenda viven en orion-shell/googleCalendar.ts (#234).
// La org y la persona salen del JWT. Google Ads usa @/lib/api_google_ads.

import { ensureFreshToken } from '@/lib/tokenRefresh';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/google-calendar';

export type EstadoCalendario = 'active' | 'needs_reconnect' | 'revoked' | string;

export interface ConexionCalendario {
  user_id: string;
  nombre: string;
  google_email: string;
  calendar_id: string;
  estado: EstadoCalendario;
  zona_horaria: string;
  /** 0 = lunes … 6 = domingo (convención de Python). */
  dias_laborales: number[];
  hora_inicio: string;
  hora_fin: string;
  booking_profile_id: number | null;
  conectado_en: string | null;
  revocado_en: string | null;
}

export interface EstadoCalendarios {
  mi_conexion: ConexionCalendario | null;
  responsables: ConexionCalendario[];
}

export class GoogleApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = 'GoogleApiError';
  }
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  await ensureFreshToken();
  const jwt = localStorage.getItem('auth_token');
  if (!jwt) throw new GoogleApiError('Sesión expirada. Inicia sesión nuevamente.', 401);
  const res = await fetch(`${DJANGO_PROXY}${BASE}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${jwt}`,
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const detail = (err as { detail?: unknown }).detail;
    const msg =
      typeof detail === 'string'
        ? detail
        : res.status === 503
          ? 'Google Calendar todavía no está configurado en el servidor.'
          : res.status === 403
            ? 'No tienes permiso para esta acción.'
            : `Error ${res.status} del servidor`;
    throw new GoogleApiError(msg, res.status);
  }
  return res.json() as Promise<T>;
}

export const getCalendarStatus = () => call<EstadoCalendarios>('/status');
